import React, { useState, useEffect } from 'react';
import '../styles/MaintenancePopup.css';

function MaintenancePopup() {
  const [isOpen, setIsOpen] = useState(true); // Start with popup open

  useEffect(() => {
    // Add event listener to prevent scrolling when popup is open
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      // Clean up by enabling scrolling when component unmounts
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]); // This will run whenever isOpen changes

  const closePopup = () => {
    setIsOpen(false);
    document.body.style.overflow = 'auto'; // Explicitly enable scrolling
  };

  const navigateToCustomerService = () => {
    window.location.href = 'https://user191427.psee.io/CODY';
  };

  if (!isOpen) return null;

  return (
    <div className="maintenance-popup-overlay">
      <div className="maintenance-popup-container">
        <button className="close-button" onClick={closePopup}>×</button>
        <div 
          className="maintenance-popup-content"
          onClick={navigateToCustomerService}
        >
          <img 
            src="/index/maintenance-popup4.jpg" 
            alt="Coming Soon" 
            className="maintenance-popup-image"
          />
        </div>
      </div>
    </div>
  );
}

export default MaintenancePopup;